import React, { useState } from 'react';
import { useAuth } from '../../hooks/use-auth';
import { signIn } from '../../services/api/auth';
import { message, Form, Input, Button } from 'antd';
import {
    GENERIC_ERROR_MESSAGE,
    validateMessages,
} from '../../constants/feedback';
import LogoLefiColorImg from '../../assets/img/LOGO_LEFI_color.png';

const itemLayout = {
    labelCol: { span: 24 },
};

const AuthPage = () => {
    const [isLoading, setLoading] = useState(false);
    const { login } = useAuth();

    const handleFinish = async (values) => {
        try {
            setLoading(true);

            const response = await signIn(values.usuario, values.password);
            login(response.data);
        } catch (error) {
            if (error.response.status === 401) {
                message.error(error.response.data.Message);
            } else {
                message.error(GENERIC_ERROR_MESSAGE);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='bg-login border-superior border-inferior'>
            <section id='container'>
                <div className='d-flex align-items-center vh-100'>
                    <div className='row row col-lg-4 ms-5 ps-5'>
                        <div className='card'>
                            <main className='form-signin mx-3'>
                                <Form
                                    onFinish={handleFinish}
                                    validateMessages={validateMessages}
                                    autoComplete='off'
                                >
                                    <div className='text-center'>
                                        <img
                                            className='my-4'
                                            src={LogoLefiColorImg}
                                            alt=''
                                            width='72'
                                            height='57'
                                        />
                                        <h1 className='h5 mb-3 fw-normal txt-color-primary'>
                                            Bienvenidos
                                        </h1>
                                    </div>

                                    <div className='col-lg-12 mb-4'>
                                        <Form.Item
                                            name='usuario'
                                            label='Usuario'
                                            {...itemLayout}
                                            rules={[
                                                {
                                                    required: true,
                                                    whitespace: true,
                                                },
                                            ]}
                                        >
                                            <Input maxLength={45} allowClear />
                                        </Form.Item>
                                    </div>

                                    <div className='col-lg-12 mb-4'>
                                        <Form.Item
                                            name='password'
                                            label='Contraseña'
                                            {...itemLayout}
                                            rules={[
                                                {
                                                    required: true,
                                                    whitespace: true,
                                                },
                                            ]}
                                        >
                                            <Input.Password
                                                maxLength={100}
                                                allowClear
                                            />
                                        </Form.Item>
                                    </div>

                                    <div className='my-5'>
                                        <Button
                                            type='primary'
                                            htmlType='submit'
                                            loading={isLoading}
                                            className='w-100'
                                        >
                                            Iniciar sesión
                                        </Button>
                                    </div>
                                </Form>
                            </main>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AuthPage;
